import { useQuery } from '@tanstack/react-query'
import { fetchWorkflows, isWorkflowsApiAvailable } from '@/services/workflows/workflowsApi'
import { workspaceScopedKey } from '@/services/workspaces/workspaceQueryKeys.js'
import { getActiveWorkspaceId } from '@/store/workspaceStore'

export function workflowsQueryKey() {
  return workspaceScopedKey(['do-chat', 'workflows'])
}

export function useWorkflows() {
  const workspaceId = getActiveWorkspaceId()
  return useQuery({
    queryKey: workflowsQueryKey(),
    queryFn: ({ signal }) => fetchWorkflows({ signal }),
    enabled: isWorkflowsApiAvailable() && Boolean(workspaceId),
    retry: false,
    staleTime: 60_000,
  })
}
